export const newSmartDocTemplate = Object.freeze({
    label: 'New Smart Doc',
    title: '',
    sections: [],
    params: [],
    _tagIds: [],
    _variableIds: [],
    _templateIds: [],
});
//# sourceMappingURL=consts.js.map